<template>
  <div class="DictTable">
    <el-dialog
      class="customDialog"
      :title="dialogTitle"
      :visible.sync="isShow"
      width="1100px"
      top="15vh"
      :close-on-click-modal = 'false'
      :close-on-press-escape = 'false'
    >
      <div class="topButtons">
        <el-button type="primary" icon="el-icon-document-add" @click="showAddDialog = true;dialogTitle2='新增'">新建</el-button>
      </div>
      <el-table
          ref="multipleTable"
          stripe
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
        >
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">
            <span class="num">{{scope.$index+1}}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item ,index) in columns"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          :formatter="item.formatter"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <div class="action-btn">
              <span @click="openEdit(scope.row)">编辑</span>
              <span class="line"></span>
              <span @click="deleteOne(scope.row)">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
<!--    新建字典项弹框-->
    <el-dialog
      class="customDialog"
      :title="dialogTitle2"
      :visible.sync="showAddDialog"
      width="870px"
      @close="closeDialog"
      top="15vh"
      :close-on-click-modal = 'false'
    >
      <el-form :inline="true" :model="formInline" :rules="rules" ref="form" label-width="100px" class="demo-form-inline">
        <el-form-item label="字典标签：" prop="dictLabel">
          <el-input class="form-input-long" v-model="formInline.dictLabel" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="字典键值：" prop="dictValue">
          <el-input class="form-input-long" v-model="formInline.dictValue" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="字典排序：" prop="dictSort">
          <el-input class="form-input-long" v-model="formInline.dictSort" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="状态：" prop="status">
          <el-select class="form-input-long" v-model="formInline.status" placeholder="请选择">
            <el-option label="正常" value="0"></el-option>
            <el-option label="禁用" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input
            class="form-input-long"
            resize="none"
            :rows="4"
            maxlength="255"
            :show-word-limit="true"
            v-model="formInline.remark"
            type="textarea"
            placeholder="请输入"
            :disabled="dialogType==='info'">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" :loading="true" v-if="loading"></el-button>
        <el-button type="primary" @click="onSubmit" v-else>确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { addDictData, getDictDataList, deleteDictData, editDictData } from '@/api/system'
export default {
  name: 'DictTable',
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  components: { },
  data () {
    return {
      showAddDialog: false,
      isShow: false,
      loading: false,
      dialogTitle: '',
      dialogTitle2: '',
      dialogType: '',
      dialogRow: null,
      formInline: {
        dictLabel: '',
        dictValue: '',
        dictSort: '',
        status: '0',
        remark: ''
      },
      rules: {
        dictLabel: [
          { required: true, message: '请输入字典标签', trigger: 'blur' }
        ],
        dictValue: [
          { required: true, message: '请输入字典键值', trigger: 'blur' }
        ],
        dictSort: [
          { required: true, message: '请输入字典排序', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择字典状态', trigger: 'change' }
        ]
      },
      tableData: [],
      columns: [
        {
          prop: 'dictCode',
          label: '字典编码'
        },
        {
          prop: 'dictLabel',
          label: '字典标签'
        },
        {
          prop: 'dictValue',
          label: '字典键值'
        },
        {
          prop: 'dictSort',
          label: '字典排序'
        },
        {
          prop: 'status',
          label: '状态',
          formatter: (row, column) => {
            return this.statusName(row.status)
          }
        },
        {
          prop: 'remark',
          label: '备注',
          width: 180
        },
        {
          prop: 'createTime',
          label: '创建时间',
          width: 180,
          formatter: (row, column) => {
            return new Date(row.createTime).format('yyyy/MM/dd hh:mm:ss')
          }
        }
      ]
    }
  },
  computed: {
  },
  watch: {
    data (newValue, oldValue) {

    }
  },
  methods: {
    open (title, type, row) {
      this.dialogTitle = title
      this.dialogType = type
      this.dialogRow = row
      this.isShow = true
      if (row) {
        this.loadTableData()
      }
    },
    statusName (status) {
      if (status === '0') {
        return '正常'
      }
      if (status === '1') {
        return '禁用'
      }
    },
    loadTableData () {
      getDictDataList({
        pageNumber: 1,
        pageSize: 1000,
        dictType: this.dialogRow.dictType
      }).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.records
        }
      })
    },
    openEdit (row) {
      this.formInline.dictCode = row.dictCode
      this.dialogTitle2 = '编辑'
      Object.keys(this.formInline).forEach(k => {
        this.formInline[k] = row[k]
      })
      this.showAddDialog = true
    },
    onSubmit () {
      if (this.dialogTitle2 === '新增') {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.loading = true
            this.formInline.dictType = this.dialogRow.dictType
            addDictData(this.formInline).then((res) => {
              if (res.code === 200) {
                this.$Message('success', res.msg)
                this.cancel()
                this.loadTableData()
              }
            }).catch(() => {
              this.loading = false
            })
          } else {
          }
        })
      }
      if (this.dialogTitle2 === '编辑') {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.loading = true
            this.formInline.dictType = this.dialogRow.dictType
            editDictData(this.formInline).then((res) => {
              if (res.code === 200) {
                this.$Message('success', res.msg)
                this.cancel()
                this.loadTableData()
              }
            }).catch(() => {
              this.loading = false
            })
          } else {
          }
        })
      }
    },
    deleteOne (row) {
      this.$Delete({
        confirm: () => {
          deleteDictData(row.dictCode).then(res => {
            if (res.code === 200) {
              this.$Message('success', res.msg)
              this.loadTableData()
            }
          })
        },
        cancel: () => {
        }
      })
    },
    cancel () {
      this.showAddDialog = false
    },
    closeDialog () {
      this.$refs.form.resetFields()
      this.formInline = this.$options.data().formInline
      this.loading = false
    }
  },
  filters: {}
}
</script>

<style lang="scss">
  .DictTable{
  }
</style>
